export const hasAvailableDrillDown = (drillDownId: string | undefined): boolean => {
  return !!drillDownId;
};
